import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedReembolsosComponent {
  data
  informacion
  viaticoId
  onChange

  constructor ($state) {
    this.$state = $state
  }

  $onInit () {
    this.data = this.data ? this.data : []
    this.totalReembolsos = this.data.reduce((total, item) => total + (item.autorizado ? item.total : 0), 0)
  }

  actualizar (item, data) {
    if (!data) {
      this.data.splice(this.data.findIndex((solicitud) => solicitud.solicitud_id === item.solicitud_id), 1)
    } else {
      Object.assign(item, data)
    }
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('viaticosSharedReembolsos', {
  controller: ViaticosSharedReembolsosComponent,
  template,
  bindings: {
    data: '<',
    informacion: '<',
    viaticoId: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/reembolsos/component.js